import { useProjectDetailsContext } from "pages/project/context/ProjectDetailsContext";

function DetailRow({ label, value }) {
  return (
    <div className="flex items-center justify-between rounded-lg border border-slate-200 bg-slate-50 p-3">
      <p className="text-xs font-semibold uppercase tracking-wide text-text-500">{label}</p>
      <p className="text-sm font-semibold text-text-900">{value}</p>
    </div>
  );
}

export default function FundingSnapshotCard() {
  const { project } = useProjectDetailsContext();

  return (
    <section className="space-y-3 rounded-xl border border-slate-200 bg-white p-4 shadow-card">
      <h3 className="text-sm font-semibold uppercase tracking-wide text-text-500">Funding Snapshot</h3>
      <DetailRow label="Funds Raised" value={project.fundsRaised} />
      <DetailRow label="Investors" value={project.investorCount} />
      <DetailRow label="Price / Share" value={project.pricePerShare} />
      <DetailRow label="Total Funding Goal" value={project.hardCap} />
      <DetailRow label="Min Investment" value={project.minimumInvestment} />
      <DetailRow label="Max Investment" value={project.maximumInvestment} />
    </section>
  );
}
